<template>
  <Toast />
</template>

<script>
export default {
  data() {
    return {};
  },

  created() {
    this.$root.$on("alert:clear", () => {
      this.$toast.removeAllGroups();
    });

    this.$root.$on("alert:success", mensagem => {
      this.$toast.add({
        severity: "success",
        summary: "Sucesso",
        detail: mensagem,
        life: 5000
      });
    });

    this.$root.$on("alert:info", mensagem => {
      this.$toast.add({
        severity: "info",
        summary: "Informação",
        detail: mensagem,
        life: 5000
      });
    });

    this.$root.$on("alert:warn", mensagem => {
      this.$toast.add({
        severity: "warn",
        summary: "Aviso",
        detail: mensagem,
        life: 5000
      });
    });

    this.$root.$on("alert:error", mensagem => {
      this.$toast.add({
        severity: "error",
        summary: "Erro",
        detail: mensagem,
        life: 5000
      });
    });

    //Funções com tempo maior
    this.$root.$on("alert:success:fixed", mensagem => {
      this.$toast.add({
        severity: "success",
        summary: "Sucesso",
        detail: mensagem,
        life: 15000
      });
    });

    this.$root.$on("alert:info:fixed", mensagem => {
      this.$toast.add({
        severity: "info",
        summary: "Informação",
        detail: mensagem,
        life: 15000
      });
    });

    this.$root.$on("alert:warn:fixed", mensagem => {
      this.$toast.add({
        severity: "warn",
        summary: "Aviso",
        detail: mensagem,
        life: 15000
      });
    });

    this.$root.$on("alert:error:fixed", mensagem => {
      this.$toast.add({
        severity: "error",
        summary: "Erro",
        detail: mensagem,
        life: 15000
      });
    });
  }
};
</script>

<style scoped>
</style>